<template>
  <div>
    <div class="title-bar title-h4">알람 조건</div>
    <el-form :model="alarmData" label-position="top" ref="alarmForm" :rules="rules">
      <el-row>
        <el-form-item label="대상 저장소" prop="dataindexId">
          <el-select v-model="alarmData.dataindexId" @change="changeDataIndex">
            <el-option
              v-for="item in dataIndexList"
              :key="item.dataindexId"
              :label="item.dataindexName"
              :value="item.dataindexId"/>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row class="mr-b25" :gutter="4">
        <el-col :span="8">
          <el-form-item label="알람 조건" prop="eventCondition">
            <el-select v-model="alarmData.eventCondition" @change="changeKeywordField">
              <el-option
                v-for="item in dataIndexFieldList"
                :key="item.fieldId"
                :label="item.fieldName"
                :value="item.fieldId"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item label="조건 값" prop="eventValue">
            <el-row class="vertical-center-box" :gutter="4">
              <el-col :span="17">
                <el-input v-model="alarmData.eventValue"></el-input>
              </el-col>
              <el-col :span="7">
                <el-checkbox v-model="alarmData.regexFlag" true-label="Y" false-label="N">정규표현식</el-checkbox>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" class="mr-b10 vertical-center-box">
        <div class="title-h4">이벤트 등급</div>
        <el-button type="primary" @click="addEventlevelSetting">이벤트 추가</el-button>
      </el-row>
      <el-table-wrapper :column-default="columnDefault" border :data="eventlevelData" :columns="eventCountColumns" :pagination="false"
        :show-custom-header="false" header-align="center" highlight-current-row>
        <template slot-scope="scope" slot="eventlevelId-slot">
          <el-select v-model="scope.row.eventlevelId" @change="checkValidEventlevel(eventlevelData, scope.row.eventlevelId)">
            <el-option
              v-for="item in eventlevelSetting"
              :key="item.eventlevelId"
              :label="item.eventlevelName"
              :value="item.eventlevelId">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="threshold-slot">
          <el-input type="Number" v-model="scope.row.eventThreshold" min="1"></el-input>
        </template>
        <template slot-scope="scope" slot="eventCheckTime-slot">
          <el-row>
            <el-col :span="13">
              <el-input type="Number" v-model="scope.row.eventcheckTime" min="1"></el-input>
            </el-col>
            <el-col :span="11">
              <el-select v-model="scope.row.eventcheckTimeUnit">
                <el-option
                  v-for="item in timeSetting"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </template>
        <template slot-scope="scope" slot="delete-row-slot">
          <span class="c-pointer" v-if="scope.$index !== 0" @click="deleteEventRow(scope, scope.$index)"><i class="fal fa-times"></i></span>
        </template>
      </el-table-wrapper>
    </el-form>
  </div>
</template>

<script>
import { isNil, findIndex } from 'lodash';
import { columnDefault } from '@/constants/table';
import AlarmAPI from '@/api/settings/log/lms-alarm-setting';
import integratedSyslogAPI from '@/api/settings/log/integrated-syslog-settings';
import msgUtil from '@/utils/message';
import AlarmSettingMixins from '../js/alarm-setting-mixins';

export default {
  name: 'WAlarmEventCountSetting',
  mixins: [AlarmSettingMixins],
  props: {
    alarmData: {
      type: Object,
    },
    eventlevelData: {
      type: Array,
    },
    eventlevelSetting: {
      type: Array,
    },
    isAdd: {
      type: Boolean,
    },
  },
  data() {
    const eventCountColumns = [
      {
        label: '이벤트 등급',
        prop: 'eventlevelId',
        width: 130,
        scopedSlot: 'eventlevelId-slot',
      },
      {
        label: '발생 횟수',
        prop: 'eventThreshold',
        scopedSlot: 'threshold-slot',
      },
      {
        label: '알람 판단 주기',
        prop: 'eventCheckTime',
        scopedSlot: 'eventCheckTime-slot',
        width: '150px',
      },
      {
        width: '50px',
        align: 'center',
        scopedSlot: 'delete-row-slot',
      },
    ];
    return {
      dataIndexList: [],
      dataIndexFieldList: [],
      columnDefault,
      eventCountColumns,
      logPatternInfo: null,
      timeSetting: [
        { value: 'S', label: '초' },
        { value: 'M', label: '분' },
        { value: 'H', label: '시' },
        { value: 'D', label: '일' },
      ],
      rules: {
        eventValue: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
      },
      checkDuplicateEventlevel: false,
    };
  },
  methods: {
    checkValidation() {
      let checkEvent = true;
      this.$refs.alarmForm.validate().then((success) => {
        if (success) {
          this.eventlevelData.forEach((item) => {
            if (item.eventThreshold <= 0 || item.eventcheckTime <= 0) {
              checkEvent = false;
            }
          });
          if (checkEvent && !this.checkDuplicateEventlevel) {
            this.$emit('increaseActiveStep');
          } else {
            this.$message(msgUtil.getCustomMsgData('이벤트 값이 잘못되었습니다'));
          }
        }
      }).catch(() => {});
    },
    /**
     * 알람 조건 변경
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changeKeywordField(data) {
      const selectField = this.dataIndexFieldList.find((item) => item.fieldId === data);
      this.alarmData.eventCondition = selectField.fieldId;
      this.alarmData.eventConditionLabel = selectField.fieldName;
    },
    /**
     * 대상 저장소 변경
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changeDataIndex(data) {
      const index = findIndex(this.dataIndexList, { dataindexId: data });
      if (index !== -1) {
        this.alarmData.dataindexName = this.dataIndexList[index].dataindexName;
      }
      const param =
      {
        dataindexId: data,
      };
      AlarmAPI.getDataIndexField(param).then((response) => {
        if (response.data.success) {
          this.dataIndexFieldList = response.data.data;
          this.alarmData.eventCondition = this.dataIndexFieldList[0].fieldId;
          this.alarmData.eventConditionLabel = this.dataIndexFieldList[0].fieldName;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '저장소 정보', false));
        throw new Error(e);
      });
    },
    /**
     * 이벤트 제거 함수
     * @author leesy918
     * @param  {[type]} scope [description]
     * @return {[type]}       [description]
     */
    deleteEventRow(scope, index) {
      this.$emit('deleteEventRow', scope, index);
      this.checkValidEventlevel(this.eventlevelData, scope.row.eventlevelId);
    },
    /**
     * 이벤트 추가 함수
     * @author leesy918
     */
    addEventlevelSetting() {
      const addData = {
        eventlevelId: this.eventlevelSetting[0].eventlevelId,
        eventcheckTimeUnit: this.timeSetting[0].value,
        eventThreshold: 1,
        eventcheckTime: 1,
      };
      this.eventlevelData.push(addData);
      this.checkValidEventlevel(this.eventlevelData, this.eventlevelSetting[0].eventlevelId);
    },
    /**
     * 발생 조건 데이터 로드 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      integratedSyslogAPI.getDataIndexes().then((response) => {
        if (response.data.success) {
          this.dataIndexList = response.data.data;
          if (this.isAdd) {
            this.alarmData.dataindexId = this.dataIndexList[0].dataindexId;
            this.changeDataIndex(this.dataIndexList[0].dataindexId);
            this.addEventlevelSetting();
          } else {
            this.getDataIndexField(this.alarmData.dataindexId);
          }
        }
      });
    },

    getDataIndexField(data) {
      const index = findIndex(this.dataIndexList, { dataindexId: data });
      if (index !== -1) {
        this.alarmData.dataindexName = this.dataIndexList[index].dataindexName;
      }
      const param =
      {
        dataindexId: data,
      };
      AlarmAPI.getDataIndexField(param).then((response) => {
        if (response.data.success) {
          this.dataIndexFieldList = response.data.data;
          if (this.isAdd) {
            this.alarmData.eventCondition = this.dataIndexFieldList[0].fieldId;
            this.alarmData.eventConditionLabel = this.dataIndexFieldList[0].fieldName;
          } else {
            const field = this.dataIndexFieldList.find((item) => item.fieldId === this.alarmData.eventCondition);
            this.alarmData.eventCondition = field.fieldId;
            this.alarmData.eventConditionLabel = field.fieldName;
          }
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '저장소 정보', false));
        throw new Error(e);
      });
    },
    /**
     * 조건설정 > 머신러닝 패턴 > 머신러닝 패턴 선택 검증 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    checkLogPattern() {
      return !(isNil(this.logPatternInfo));
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/popup/components/AlarmEventCountSetting.vue